import { useLocalStorage as baseUseLocalStorage } from '@vueuse/core';

import { browserStorageNamespacedKey } from '@/utils/browserStorage';

export function useLocalStorage(key, initialValue = null, options = {}) {
  const dhKey = browserStorageNamespacedKey(key);
  return baseUseLocalStorage(dhKey, initialValue, options);
}
